import axios from "../../axios";
import { API } from "../../constants";
import i18n from "../../i18n";
import * as actionTypes from "./actionTypes";
import { setUserInfoAndUpdateToken } from "./user";

export const addStorage = () => {
  return {
    type: actionTypes.ADD_STORAGE,
  };
};

export const removeStorage = (name) => {
  return {
    type: actionTypes.REMOVE_STORAGE,
    ingredientName: name,
  };
};

export const setStorages = (storages) => {
  return {
    type: actionTypes.SET_DEPOSITS,
    storages: storages,
  };
};

export const fetchStoragesFailed = (error = "") => {
  if (error) return { type: actionTypes.FETCH_DEPOSITS_FAILED, error };
  return { type: actionTypes.FETCH_DEPOSITS_FAILED };
};

export const setStoragesLoading = () => {
  return {
    type: actionTypes.FETCH_DEPOSITS_STARTING,
  };
};

export const initStorages = (language = i18n.language) => {
  return (dispatch) => {
    dispatch(setStoragesLoading());
    
    axios
      .get(`${API}${language}/angel/deposits`)
      .then((response) => {
        dispatch(setStorages(response.data));
      })
      .catch((error) => {
        console.log("err storages:", error);
        dispatch(fetchStoragesFailed());
      });
  };
};

export const registerNewProperty = (values) => {
  return async (dispatch) => {
    dispatch(setStoragesLoading());

    return await axios
      .post(`${API}organization/item/${values.id}/storage`, values.data)
      .then(async () => {
        dispatch(addStorage());

        return await axios
          .get(`${API}${i18n.language}/auth/token/refresh`)
          .then((response) => {
            dispatch(setUserInfoAndUpdateToken(response.data));
            return true;
          })
          .catch((error) => {
            console.log("err", error);
            return false;
          });
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchStoragesFailed(error.response.data));
        return false;
      });
  };
};

export const registerFirstStorage = (values) => {
  return async (dispatch) => {
    dispatch(setStoragesLoading());

    return await axios
      .post(`${API}organization/external/storage`, { ...values })
      .then(async () => {
        dispatch(addStorage());

        return await axios
          .get(`${API}${i18n.language}/auth/token/refresh`)
          .then((response) => {
            dispatch(setUserInfoAndUpdateToken(response.data));
            return true;
          })
          .catch((error) => {
            console.log("err", error);
            return false;
          });
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchStoragesFailed(error.response.data));
        return (
          error?.response?.data?.context === "OrganizationCreate" &&
          error?.response?.data?.invalid_fields?.id?.includes("The organization already exists")
        );
      });
  };
};
